import React, { useEffect, useState } from "react";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import IconShow from "canvas-core-react/lib/IconShow";
import IconSuccess from "canvas-core-react/lib/IconSuccessUniversal";
// import IconDelete from "canvas-core-react/lib/IconDelete";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import BillsStatus from "../../shared/status";
import FilterComponent from "../../utils/searchBar";
import Modal from "../../utils/customModal";
import Table from "../../shared/table";
import RelationDetail from "./RelationDetail";
import useApi from "../../hooks/useApi";
import {
  loadingHtml,
  formatDashDate,
  moduleAction,
  sucessInfoModal,
} from "../../utils/functions";
import { getAuthenticatedClientModules } from "../../../Redux/actions/clientActions";
import { MOD_RELATIONS, WRITE } from "../../../permissions";
import { getRoles } from "../../../Redux/reducer/session";
import { getModules } from "../../../Redux/reducer/clients";

const defaultModal = {
  show: false,
  content: loadingHtml(),
};

const RelationList = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { getApiCAll, putApiCAll, cancellCall } = useApi();
  const [data, setData] = useState({});
  const [detail, setDetail] = useState({ show: false, companyId: null });
  const [query, setQuery] = useState("");
  const [modal, setModal] = useState(defaultModal);
  const [menu, setMenu] = useState([]);
  const [pagination, setPagination] = useState({ page: 0, sizePerPage: 10 });

  const { roles, approvals } = useSelector((state) => ({
    roles: getRoles(state),
    approvals: getModules(state).find(
      ({ module }) => module.code === "MOD_RELATIONS"
    )?.numberOfApprovals,
  }));

  const hasPermissions = moduleAction(roles, MOD_RELATIONS, WRITE);

  const dispatch = useDispatch();

  useEffect(() => {
    setMenu([]);
    const { page, sizePerPage } = pagination;
    getRelations({ page, sizePerPage });
    dispatch(getAuthenticatedClientModules());

    return () => cancellCall();
  }, []);

  const getRelations = async ({ page, sizePerPage, querystring = null }) => {
    setModal({ ...defaultModal, show: true });
    try {
      const customQuery = querystring || query;
      const searchQuery = `status/not/DELETED${
        customQuery ? `|${customQuery}` : ""
      }`;

      const {
        data: { data },
      } = await getApiCAll(`/providers/company-provider-relations`, undefined, {
        page,
        size: sizePerPage,
        search: searchQuery,
      });

      setData({
        content: data.content.map((item) => ({
          companyId: item.company.id,
          company: item.companyName,
          businessId: item.businessId,
          bills: item.provider.quantityBills,
          date: formatDashDate(item.createDate),
          account: item.providerAccountNumber,
          providerAccountCurrency: item.providerAccountCurrency,
          status: <BillsStatus statusCode={item.provider.status} />,
          globalApproval: item.provider.globalApproval ? "Si" : "No",
          state:
            item.companyProviderInvitationStatus !== null &&
            item.companyProviderInvitationStatus !== undefined
              ? t(
                  `general.inviteStates.${item.companyProviderInvitationStatus}`
                )
              : "",
          item,
        })),
        totalElements: data.totalElements,
      });
      setQuery(customQuery);
      setPagination({ page, sizePerPage });
    } catch (error) {
      console.error(error);
    }
    setModal(defaultModal);
  };

  const handleMenu = (id, open) => {
    const tmpMenu = { ...menu };
    tmpMenu[`menu-${id}`] = open;
    setMenu(tmpMenu);
  };

  const closeModal = () => setModal(defaultModal);

  const getHeaders = () => [
    { selector: "company", name: t("providers.table.headers.company") },
    {
      selector: "businessId",
      name: t("providers.table.headers.identification"),
    },
    { selector: "bills", name: t("providers.table.headers.invoices") },
    { selector: "account", name: t("providers.table.headers.account") },
    { selector: "status", name: t("providers.table.headers.state") },
    { selector: "state", name: t("providers.table.headers.invitationState") },
    {
      selector: "globalApproval",
      name: t("providers.table.headers.globalApproval"),
    },
    {
      selector: "actions",
      name: t("providers.table.headers.action"),
      center: true,
      cellFormatter: (row) => {
        const uniqueId = `${row.item.id}-${row.providerAccountCurrency}`;
        return (
          <ActionMenuList
            dialogPosition="bottom-right"
            iconType="horizontal-small"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel",
              },
            }}
            isMenuOpen={menu[`menu-${uniqueId}`] || false}
            setIsMenuOpen={(open) => handleMenu(uniqueId, open)}
          >
            {options.map(({ label, Icon, id }) =>
              id > 1 && !hasPermissions ? null : (
                <ActionMenuListItem
                  key={label}
                  icon={() => (
                    <Icon
                      id={`${id}-${uniqueId}`}
                      className="TextButton__icon--left"
                    />
                  )}
                  onClick={() => {
                    handleMenu(uniqueId, false);
                    action(id, row);
                  }}
                >
                  {t(`general.labels.fileModal.${label}`)}
                </ActionMenuListItem>
              )
            )}
          </ActionMenuList>
        );
      },
    },
  ];

  const action = (id, { item, companyId, providerAccountCurrency }) => {
    if (id === 1) return handleDetails(companyId, providerAccountCurrency);

    const globalMode = id === 2;
    const globalAction = item.provider.globalApproval
      ? "desactivar"
      : "activar";

    let title = globalMode
      ? `Desea ${globalAction} aprobación global`
      : t("clients.deleteRelationTitle");

    let message = globalMode
      ? approvals
        ? "La aprobación global requiere una aprobación de un autorizador del BSC."
        : `¿Está seguro de que se desea ${globalAction} la aprobación global?`
      : t("clients.deleteRelationDescription");

    setModal({
      show: true,
      content: sucessInfoModal(title, message, {
        SelBtn: { text: "Cancelar", action: closeModal },
        formBtn: {
          text: "Aceptar",
          action: () => requestAction(item, globalMode),
        },
      }),
    });
  };

  const handleDetails = (companyId, providerAccountCurrency) => {
    history.push(
      `/providerSite/relations/detail/${companyId}/${providerAccountCurrency}`
    );
  };

  const requestAction = async (
    { company, provider, providerAccountCurrency },
    global
  ) => {
    const url = global ? "csa-global-approval" : "csa-remove-provider-company";
    setModal({ ...defaultModal, show: true });
    try {
      await putApiCAll(`/providers/${url}`, {
        companyId: company.id,
        providerId: provider.id,
        [global ? "currency" : "accountCurrency"]: providerAccountCurrency,
        ...(global && { globalAcceptance: !provider.globalApproval }),
      });
      getRelations({ page: 0, sizePerPage: pagination.sizePerPage });
    } catch (error) {
      setModal({
        show: true,
        content: sucessInfoModal(
          "Error",
          "Ha ocurrido un error inesperado, favor intente mas tarde",
          { formBtn: { text: "Aceptar", action: closeModal } }
        ),
      });
    }
  };

  const search = (type, value) => {
    let querystring = "";
    let selectedFilter = filters.filter((item) => item.property === type);

    if (selectedFilter.length > 0) {
      querystring = `${type}/${selectedFilter[0].operator}/${value}`;
    }
    getRelations({ page: 0, sizePerPage: 10, querystring });
  };

  const goBack = () => {
    setDetail({ show: false, companyId: null });
  };

  return (
    <>
      {data.content &&
        (!detail.show ? (
          <>
            <div className="flex-element left-flex">
              <FilterComponent filter={filters} searchFnc={search} />
            </div>
            <Table
              headers={getHeaders()}
              data={data.content}
              totalSize={data.totalElements}
              sizePerPage={pagination.sizePerPage}
              page={pagination.page}
              onTableChange={getRelations}
            />
          </>
        ) : (
          <RelationDetail companyId={detail.companyId} goBack={goBack} />
        ))}
      <Modal show={modal.show}>{modal.content}</Modal>
    </>
  );
};

export default RelationList;

const filters = [
  {
    name: "Nombre",
    property: "company.institution.companyName",
    operator: "eq",
  },
  {
    name: "Identificación",
    property: "company.institution.businessId",
    operator: "eq",
  },
];

const options = [
  {
    id: 1,
    Icon: IconShow,
    label: "detail",
  },
  {
    id: 2,
    Icon: IconSuccess,
    label: "globalApproval",
  },
  // {
  //   id: 3,
  //   Icon: IconDelete,
  //   label: "deleteRelation",
  // },
];
